/**
 * This modal is kept for legacy purposes, any new modals should use the ModalReact component.
 */

import React, { Component, ReactNode } from "react";
import { Modal as BootstrapModal } from "bootstrap.native";
export interface Props {
  onClose?: EventListenerOrEventListenerObject;
  title?: string;
  titleIcon?: string;
  children?: ReactNode;
  primaryButtonText?: string;
  primaryButtonClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  isOpen: boolean;
  customFooter?: JSX.Element;
  modalBodyClassName?: string;
  primaryButtonClassName?: string;
  hideFooter?: boolean;
}
interface State {
  renderModal: boolean;
}
export default class Modal extends Component<Props, State> {
  private modal?: BootstrapModal;
  private element: React.RefObject<HTMLDivElement>;
  public constructor(props: Props) {
    super(props);
    this.element = React.createRef();
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    const {
      isOpen
    } = this.props;
    this.state = {
      renderModal: isOpen
    };
  }
  public componentDidMount() {
    const {
      onClose,
      isOpen
    } = this.props;
    if (!this.element.current) return;
    this.modal = new BootstrapModal(this.element.current);
    if (isOpen) {
      this.modal.show();
    }
    if (onClose) this.element.current.addEventListener("hidden.bs.modal", onClose);
    this.element.current.addEventListener("show.bs.modal", this.openModal);
    this.element.current.addEventListener("hidden.bs.modal", this.closeModal);
  }
  public componentDidUpdate(prevProps: Props) {
    const {
      isOpen
    } = this.props;
    if (isOpen !== prevProps.isOpen && this.modal) {
      this.modal[isOpen ? "show" : "hide"]();
    }
  }
  public componentWillUnmount() {
    if (!this.element.current) return;
    this.element.current.removeEventListener("show.bs.modal", this.openModal);
    this.element.current.removeEventListener("hidden.bs.modal", this.closeModal);
  }
  openModal() {
    this.setState({
      renderModal: true
    });
  }
  closeModal() {
    this.setState({
      renderModal: false
    });
  }
  public render() {
    const {
      title,
      children,
      primaryButtonText,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      primaryButtonClick = () => {},
      className = "",
      customFooter,
      modalBodyClassName = "",
      primaryButtonClassName,
      hideFooter
    } = this.props;
    const {
      renderModal
    } = this.state;
    return <div className={`modal fade bs-native ${className}`} tabIndex={-1} role="dialog" ref={this.element} data-sentry-component="Modal" data-sentry-source-file="index.tsx">
        {renderModal && <div className="modal-dialog" role="document">
            <div className="modal-content">
              {title && <div className="modal-header modal-header--gray-lg">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3 className="modal-title">{title}</h3>
                </div>}
              <div className={`modal-body ${modalBodyClassName}`}>
                {children}
              </div>
              {customFooter ? <div className="modal-footer">{customFooter}</div> : !hideFooter && <div className="modal-footer">
                    {primaryButtonText && <button type="button" className={`btn ${primaryButtonClassName || "btn-primary"}`} onClick={primaryButtonClick}>
                        {primaryButtonText}
                      </button>}
                    <button type="button" className="btn btn-light" data-dismiss="modal">
                      Close
                    </button>
                  </div>}
            </div>
          </div>}
      </div>;
  }
}